import * as types from '../store/types';
import resources from '../helpers/resources';

const client = resources();

function setPayMethods(pms) {
  return {
    type: types.PAY_METHODS_FETCHED,
    payload: pms,
  };
}

export function fetchPayMethods() {
  return async (dispatch) => {
    const resp = await client.getPayMethods();

    dispatch(setPayMethods(resp.data));

    return resp;
  };
}

export function setPayWaysForPayMethod(payMethodId, payWays) {
  return {
    type: types.PAY_WAYS_FOR_PAY_METHOD_FETCHED,
    payload: {
      id: payMethodId,
      data: payWays,
    },
  };
}

export function fetchPayWaysForPayMethod(payMethodId) {
  return async (dispatch) => {
    const resp = await client.getPayWaysForPayMethod(payMethodId);

    dispatch(setPayWaysForPayMethod(payMethodId, resp.data));

    return resp;
  };
}
